import InputError from "components/InputError";
import { useField } from "formik";
import "components/v2/FormField/formFields.css";

export default function SelectField({ name, placeholder, className = "", children, label, ...rest }) {
  const [field, meta] = useField(name);
  const error = meta.touched && meta.error;
  return <div className={`akello-field${error ? " has-error" : ""}`}>
    {label && <label htmlFor={name} className="akello-field-label">{label}</label>}
    <select {...field} {...rest} id={name} aria-invalid={!!error} aria-describedby={error ? `${name}-error` : undefined} className={`akello-field-control akello-control ${className}`}>
      <option value="">{placeholder || "Select an option"}</option>{children}
    </select>
    {error && <InputError id={`${name}-error`} error={error} />}
  </div>;
}
